if (!customElements.get('dsk-cart-questions')) {
  customElements.define(
    'dsk-cart-questions',
    class DskCartQuestions extends HTMLElement {
      connectedCallback() {
        this.professionFields = this.querySelector('[data-dsk-profession-fields]');
        this.profession = this.querySelector('[data-dsk-profession]');
        this.clearProfession = this.querySelector('[data-dsk-profession-clear]');
        this.updateVersion = 0;
        this.setProfessionRequired(!this.profession.disabled);
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => this.onCartUpdate(event));
      }

      disconnectedCallback() {
        this.unsubscribe?.();
        this.updateVersion += 1;
      }

      setProfessionRequired(required) {
        this.professionFields.hidden = !required;
        this.profession.required = required;
        this.profession.disabled = !required;
        this.clearProfession.disabled = required;
        if (!required) this.profession.value = '';
      }

      async onCartUpdate(event) {
        if (event.cartData?.errors) return;
        const updateVersion = ++this.updateVersion;
        let cart = event.cartData;

        // Quantity/removal responses contain the full cart. Add responses may
        // contain only the added item, so read the current cart in that case.
        if (!Array.isArray(cart?.items) || typeof cart.item_count !== 'number') {
          try {
            const response = await fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
            if (!response.ok) return;
            cart = await response.json();
          } catch {
            return;
          }
        }

        // Do not let an older, slower read overwrite a newer cart update.
        if (updateVersion !== this.updateVersion || !Array.isArray(cart?.items)) return;
        this.setProfessionRequired(
          cart.items.some((item) => String(item.product_id) === this.dataset.professionalProductId)
        );
      }
    }
  );
}
